// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  background-color: #ffffff;
  zoom: 0.8;
  min-height: 100vh;
  width: "100%";
}

.section-gap {
  margin-top: 21px;
  margin-bottom: 10.5px;
}

.section-bg-gap {
  margin-top: 40px;
  margin-bottom: 20px;
}

.section-b-gap {
  border-top: 1px solid #e5e5e5;
  margin: 25px 0 20px;
  padding: 19px 0 25px 0;
}

.page-header {
  padding-bottom: 9.5px;
  margin: 42px 0 21px;
}

.border-bt {
  border-bottom: 1px solid #eee;
}

.flex-container {
  display: flex;
  flex-direction: row;
}
.flex-container-d {
  display: flex;
  flex-direction: row;
  gap:200px
}
.flex-container-m{
  display: flex;
  flex-direction: column;
}
.createdby-container{
  border: 1px solid #e0e0e0;
  padding: 8px;
  width: 900px;
  margin-top:10px;
}

.flex-right {
  justify-content: right;
}

.flex-center {
  justify-content: center;
}

.padding-m-b {
  padding-bottom: 10px;
}

@media only screen and (min-width: 1280px) {
  .form-layout {
    padding: 0px 20px;
  }
}
@media (max-width: 899px)  {
  .createdby-container{
    width:100%
  }
}


.grid-actions {
  border-bottom: 1px solid #eee;
  margin-bottom: 9px;
  padding-bottom: 9px;
}

.margin-sm-bt {
  margin-bottom: 20px;
}

.padding-sm-t {
  padding-top: 16px;
}

.MuiInputBase-input{
  padding:10px !important;
  padding-right:18px !important;
}
.MuiList-root{
  zoom:0.8;
}

.MuiPickersLayout-contentWrapper{
  zoom:0.8;
}
.MuiList-root{
    width:100% !important;
}
.MuiPaper-elevation8{
  min-width: 10px !important;
}

.login-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90vh;
}
.login-desc {
  text-align: center;
  align-items: center;
  padding:0px 20px;
}
.click-btn{
  cursor:pointer;
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB;AACF;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE;EACF;AACF;;;AAGA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;AAC/B;AACA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;AACA;IACI,qBAAqB;AACzB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,0BAA0B;AAC5B","sourcesContent":[".App {\n  background-color: #ffffff;\n  zoom: 0.8;\n  min-height: 100vh;\n  width: \"100%\";\n}\n\n.section-gap {\n  margin-top: 21px;\n  margin-bottom: 10.5px;\n}\n\n.section-bg-gap {\n  margin-top: 40px;\n  margin-bottom: 20px;\n}\n\n.section-b-gap {\n  border-top: 1px solid #e5e5e5;\n  margin: 25px 0 20px;\n  padding: 19px 0 25px 0;\n}\n\n.page-header {\n  padding-bottom: 9.5px;\n  margin: 42px 0 21px;\n}\n\n.border-bt {\n  border-bottom: 1px solid #eee;\n}\n\n.flex-container {\n  display: flex;\n  flex-direction: row;\n}\n.flex-container-d {\n  display: flex;\n  flex-direction: row;\n  gap:200px\n}\n.flex-container-m{\n  display: flex;\n  flex-direction: column;\n}\n.createdby-container{\n  border: 1px solid #e0e0e0;\n  padding: 8px;\n  width: 900px;\n  margin-top:10px;\n}\n\n.flex-right {\n  justify-content: right;\n}\n\n.flex-center {\n  justify-content: center;\n}\n\n.padding-m-b {\n  padding-bottom: 10px;\n}\n\n@media only screen and (min-width: 1280px) {\n  .form-layout {\n    padding: 0px 20px;\n  }\n}\n@media (max-width: 899px)  {\n  .createdby-container{\n    width:100%\n  }\n}\n\n\n.grid-actions {\n  border-bottom: 1px solid #eee;\n  margin-bottom: 9px;\n  padding-bottom: 9px;\n}\n\n.margin-sm-bt {\n  margin-bottom: 20px;\n}\n\n.padding-sm-t {\n  padding-top: 16px;\n}\n\n.MuiInputBase-input{\n  padding:10px !important;\n  padding-right:18px !important;\n}\n.MuiList-root{\n  zoom:0.8;\n}\n\n.MuiPickersLayout-contentWrapper{\n  zoom:0.8;\n}\n.MuiList-root{\n    width:100% !important;\n}\n.MuiPaper-elevation8{\n  min-width: 10px !important;\n}\n\n.login-btn {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 90vh;\n}\n.login-desc {\n  text-align: center;\n  align-items: center;\n  padding:0px 20px;\n}\n.click-btn{\n  cursor:pointer;\n  text-decoration: underline;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
